<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <table class="c-indicator c-indicator-w-100">
      <thead>
        <tr>
          <th class="tab-wid-80">№<br /></th>
          <th class="tab-wid-250">Наименование типа закупаемой радиоэлектронной продукции</th>
          <th class="tab-wid-250">№ записи в Едином реестре российской радиоэлектронной продукции, сформированный в соответствии с ПП РФ от 10.07.2019 № 878, от 17.07.2015 № 719</th>
          <th class="tab-wid-250">№ статьи / подстатьи затрат в соответствии со сметой</th>
          <th class="tab-wid-80"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in $parent.project.ELECTRONIC_PRODUCTS_PLANNED.items">
          <td class="tab-wid-80">{{ index + 1 }}</td>
          <td class="tab-wid-80 break">{{ item.UF_NAME }}</td>
          <td class="tab-wid-80 break">
             {{ item.UF_NUMBER }}
          </td>
          <td>{{ getNameSourceArtilce(item.UF_BUDGET_ARTICLE_ID) }}</td>
          <td
            v-if="
              !$parent.project.projectDisabled &&
                !$parent.project.UF_IS_BLOCK &&
                $parent.project.UF_SETTING.IS_EQUIPMENT_ACCEPT !== 1 &&
                !isPurchasedListCoordinated
            "
          >
            <i class="i-edit centerIcon" @click="editItem(index)"></i>
            <i
              class="i-delete centerIcon"
              title="Удалить запись"
              @click="deleteItem(index, item)"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <div
      class="add-row"
      v-show="
        !$parent.project.projectDisabled &&
          !$parent.project.UF_IS_BLOCK &&
          $parent.project.UF_SETTING.IS_EQUIPMENT_ACCEPT !== 1 &&
          !isPurchasedListCoordinated
      "
    >
      <a class="link-add-row" @click="showAddItem">Добавить</a>
    </div>
    <div
      class="modal fade in"
      v-bind:class="{ show: showForm }"
      tabindex="-1"
      role="dialog"
    >
      <form v-on:submit.prevent="submit">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                @click="showForm = false"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">
                {{ !isAddNewForm ? "Изменить" : "Добавить" }}
                позицию
              </h4>
            </div>
            <div class="modal-body">
              <div
                class="form-group"
                v-bind:class="{ 'has-error': checkError('UF_TYPE_PRODUCT_ID') }"
              >
                <label
                  >Наименование типа закупаемой радиоэлектронной продукции<span class="red">*</span></label
                >
                <select
                  class="form-control"
                  v-model="item.UF_TYPE_PRODUCT_ID"
                >
                  <option
                    v-for="item in $parent.project.ELECTRONIC_PRODUCTS_PLANNED.spList"
                    v-bind:key="item.ID"
                    v-bind:value="item.ID"
                    v-text="item.NAME">
                  </option>
                </select>
              </div>
              <div
                class="form-group"
                v-bind:class="{
                  'has-error': checkError('UF_NUMBER')
                }"
              >
                <label>№ записи в Едином реестре российской радиоэлектронной продукции, сформированный в соответствии с ПП РФ от 10.07.2019 № 878, от 17.07.2015 №&nbsp;719<span class="red">*</span></label>
                <textarea
                  class="form-control"
                  v-model="item.UF_NUMBER"
                ></textarea>
              </div>
              <div
                class="form-group"
                v-bind:class="{ 'has-error': checkError('UF_BUDGET_ARTICLE_ID') }"
              >
                <label
                >№ статьи / подстатьи затрат в соответствии со сметой<span class="red">*</span></label
                >
                <select
                  class="form-control"
                  v-model="item.UF_BUDGET_ARTICLE_ID"
                  :disabled="$parent.project.ELECTRONIC_PRODUCTS_PLANNED.spArticleList.length == 1"
                >
                  <option
                    v-for="item in $parent.project.ELECTRONIC_PRODUCTS_PLANNED.spArticleList"
                    v-bind:key="item.ID"
                    v-bind:value="item.ID"
                    v-text="item.NAME">
                  </option>
                </select>
              </div>
              <button type="button" @click="submit" class="btn btn-info">
                Сохранить
              </button>
              <button
                type="button"
                @click="showForm = false"
                class="btn btn-default btn-style-big"
              >
                Отмена
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { FETCH_DIRECTORIES } from "@/store/actions.type";
import { mapGetters } from "vuex";
import { ProjectsService } from "@/common/api.service";
export default {
  name: "ElectronicProductsPlanned",
  data() {
    return {
      showForm: false,
      editIndex: -1,
      item: {},
      errorFields: {},
      isAddNewForm: true,
      nameEquipment: "ProjectElectronicProductsPlannedModel"
    };
  },
  created() {
    //this.$store.dispatch(FETCH_DIRECTORIES, ["sp_source_financing"]);
  },
  methods: {
    showAddItem() {
      this.setError("");
      this.editIndex = -1;
      this.item = {};
      this.isAddNewForm = true;
      ProjectsService.getSpElectronicListByProject(this.$parent.project.ID).then(({ data }) => {
        this.$parent.project.ELECTRONIC_PRODUCTS_PLANNED.spList = data;
        if (this.$parent.project.ELECTRONIC_PRODUCTS_PLANNED.spArticleList.length == 1) {
          this.item.UF_BUDGET_ARTICLE_ID = this.$parent.project.ELECTRONIC_PRODUCTS_PLANNED.spArticleList[0].ID;
        }
        this.showForm = true;
      }, this);

      this.item.UF_SORT_NUMBER = (this.$parent.project.ELECTRONIC_PRODUCTS_PLANNED.items.length + 1);
      console.log(this.item);
    },
    editItem(index) {
      this.setError("");
      this.editIndex = index;
      this.isAddNewForm = false;
      this.item = JSON.parse(
        JSON.stringify(this.$parent.project.ELECTRONIC_PRODUCTS_PLANNED.items[index])
      );
      this.showForm = true;
    },
    deleteItem(index, item) {
      this.item = item;
      if (confirm("Вы уверены, что хотите удалить запись?")) {
        this.deleteItemAction(index, item);
      }
    },
    deleteItemAction(index){
      ProjectsService.deleteEqipmentProject(this.$parent.project.ID, this.nameEquipment, this.item.ID).then(({ data }) => {
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 10000
            });
          }, this);
        } else {
          this.$toasted.show("Запись успешно удалена", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });

          this.$parent.project.ELECTRONIC_PRODUCTS_PLANNED.items.splice(index, 1);

          this.$parent.project.ELECTRONIC_PRODUCTS_PLANNED.items.forEach(function(itemTemp, index2) {
            if (index2 >= index) {
              this.$parent.project.ELECTRONIC_PRODUCTS_PLANNED.items[index2].UF_SORT_NUMBER= parseInt(itemTemp.UF_SORT_NUMBER) - 1;
            }
          }, this);


        }
      }, this).catch(error => {
        this.handleModuleBlocked(error);
      });
    },
    handleModuleBlocked(error) {
      const status = (error && error.response && error.response.status) || 0;
      const messageHas403 = error && error.message && error.message.indexOf("403") !== -1;
      if (status === 403 || messageHas403) {
        this.$toasted.show("Модуль заблокирован Сотрудником ДМКП", {
          theme: "red",
          position: "bottom-right",
          duration: 10000
        });
      }
    },
    submit() {
      this.setError("");
      if (!this.item.UF_TYPE_PRODUCT_ID) {
        this.setError("UF_TYPE_PRODUCT_ID");
      }
      if (!this.item.UF_NUMBER) {
        this.setError("UF_NUMBER");
      }
      if (!this.item.UF_BUDGET_ARTICLE_ID) {
        this.setError("UF_BUDGET_ARTICLE_ID");
      }
      if (Object.keys(this.errorFields).length) {
        return;
      }

      let t = this.$parent.project.ELECTRONIC_PRODUCTS_PLANNED.spList.filter(c => c.ID === this.item.UF_TYPE_PRODUCT_ID);
      if (t.length > 0) {
        this.item.UF_TYPE_TABLE = t[0].TABLE;
        this.item.UF_NAME = t[0].NAME;
      }

      if (this.editIndex > -1) {
        //редактирование записи
        ProjectsService.saveEqipmentProject(this.$parent.project.ID, this.nameEquipment, this.item.ID, this.item).then(({ data }) => {
          if (data.error) {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
          } else {
            this.$toasted.show("Запись успешно изменена", {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            });

            this.$parent.project.ELECTRONIC_PRODUCTS_PLANNED.items[
              this.editIndex
              ] = JSON.parse(JSON.stringify(this.item));

            this.showForm = false;
          }
        }, this).catch(error => {
          this.handleModuleBlocked(error);
        });
      } else {
        ProjectsService.addEqipmentProject(this.$parent.project.ID, this.nameEquipment, this.item).then(({ data }) => {
          if (data.error) {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 10000
              });
            }, this);
          } else {
            this.$toasted.show("Запись успешно добавлена", {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            });
            this.item.ID = data.ID;
            this.$parent.project.ELECTRONIC_PRODUCTS_PLANNED.items.push(this.item);
            this.showForm = false;
          }
        }, this).catch(error => {
          this.handleModuleBlocked(error);
        });
      }
      //this.showForm = false;
      return false;
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    setError(field, val) {
      if (!field) {
        this.errorFields = {};
        return;
      }
      this.errorFields[field] = val ? val : true;
    },
    checkError(field) {
      if (this.errorFields[field]) {
        return true;
      }
      return false;
    },
    countEntChar(value, limit) {
      if (value) {
        const length = String(value).length;
        return length > limit ? 0 : limit - length;
      }
      return limit;
    },
    getNameSourceArtilce(id) {
      if (id > 0) {
        let t = this.$parent.project.ELECTRONIC_PRODUCTS_PLANNED.spArticleList.filter(c => c.ID === id);
        if (t.length > 0) {
          return t[0].NAME;
        }
      }
      return "";
    }
  },
  computed: {
    ...mapGetters(["directory"]),
    isPurchasedListCoordinated() {
      const list =
        this.$parent && this.$parent.project && this.$parent.project.COORDINATIONS;
      if (!Array.isArray(list)) {
        return false;
      }
      return list.some(
        el =>
          el &&
          (el.UF_TYPE_PAGE === "list_of_purhased_10_01") &&
          (el.UF_IS_COORDINATION == 1 || el.UF_IS_COORDINATION === true)
      );
    }
  }
};
</script>

<style scoped></style>
